export default __webpack_public_path__ + "static/media/rockhand.b9800f92.png";